/**
 * Vite Interstellar Environment Variables
 *
 * Use this configuration file to using specific environment variables within Interstellar.
 * Note that Vite requires variables to be prefixed with `VITE_` in order for the values to be exposed to `import.meta.env`
 *
 * There is a global mock of this file within `jest/setupTests.js`.
 * When introducing new environment variables, ensure that `jest/setupTests.js`is also updated.
 *
 * @see {@link https://vite.dev/guide/env-and-mode}
 * @see {@link file://./../jest/setupTests.js}
 */

/**
 * VITE_APP_DATADOG_RUM_CLIENT_TOKEN
 *
 * Retrieves the DataDog client token from environment vars
 *
 * @see {@link file://./datadogService.ts}
 */
export const getDatadogClientToken = () =>
    import.meta.env.VITE_APP_DATADOG_RUM_CLIENT_TOKEN;

/**
 * VITE_APP_VERSION
 *
 * Retrieves the App version from environment vars
 *
 * @see {@link file://./datadogService.ts}
 */
export const getAppVersion = () => import.meta.env.VITE_APP_VERSION;

/**
 * VITE_DRIVER_COST_SERVICE_BASE_URL
 *
 * Retrieves the explicit Driver Cost service API base URL. When unset, driver
 * cost formula persistence remains disabled.
 */
export const getDriverCostServiceBaseUrl = () =>
    import.meta.env.VITE_DRIVER_COST_SERVICE_BASE_URL;

/**
 * Allows the redux migration debugging messages to be displayed for all browser environments
 *
 * @see {@link file://./../src/store/store.ts}
 */
export const getReduxDebugMigration = () => true;
